const Form = ({
  children,
  ...rest
}: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className="flex flex-col gap-20" {...rest}>
    {children}
  </form>
);

export default Form;
